export default "__VITE_ASSET__91vupTMg__"